import { reactive } from 'vue';

export const paramsState = reactive({
    setupPasswordValidForSeconds: null
});

export function setParams(params) {
    if (!params) {
        paramsState.setupPasswordValidForSeconds = null;
        return;
    }

    paramsState.setupPasswordValidForSeconds = params.setupPasswordValidForSeconds;
}